import type { ReturnMessageTypeEnum } from '@/rtkApi/mddApiSliceGeneratedV2'
import { useAppContext } from '@/hooks'
import { useMemo } from 'react'

const MESSAGE_KEYS: Partial<Record<ReturnMessageTypeEnum, string>> = {
	INCOMPATIBLE_TARGET: 'INCOMPATIBLE_TARGET',
	CUSTOM_ATTRIBUTE_NOT_FOUND: 'CUSTOM_ATTRIBUTE_NOT_FOUND',
	OBJECT_SETTING_NOT_FOUND: 'OBJECT_SETTING_NOT_FOUND',
	OWNER_NOT_FOUND: 'OWNER_NOT_FOUND',
	BUSINESS_DOMAIN_NOT_FOUND: 'BUSINESS_DOMAIN_NOT_FOUND',
	RESPONSIBLE_ANALYST_NOT_FOUND: 'RESPONSIBLE_ANALYST_NOT_FOUND',
	RESPONSIBLE_PERSON_NOT_FOUND: 'RESPONSIBLE_PERSON_NOT_FOUND',
	DOMAIN_NOT_FOUND: 'DOMAIN_NOT_FOUND',
	STEREOTYPE_NOT_FOUND: 'STEREOTYPE_NOT_FOUND',
	TABLE_ALREADY_EXISTS: 'TABLE_ALREADY_EXISTS',
	INCONSISTENT_TABLES: 'INCONSISTENT_TABLES',
	INCONSISTENT_DOMAINS: 'INCONSISTENT_DOMAINS',
	COLUMN_WITH_SAME_NAME_ALREADY_EXISTS: 'COLUMN_WITH_SAME_NAME_ALREADY_EXISTS',
	COLUMN_WITH_SAME_CODE_ALREADY_EXISTS: 'COLUMN_WITH_SAME_CODE_ALREADY_EXISTS',
	DUPLICATE_COLUMN_NAME: 'DUPLICATE_COLUMN_NAME',
	DUPLICATE_COLUMN_CODE: 'DUPLICATE_COLUMN_CODE',
	TECHNICAL_COLUMN_COLLISION: 'TECHNICAL_COLUMN_COLLISION',
	SYSTEM_USER_NOT_FOUND: 'SYSTEM_USER_NOT_FOUND',
}

export const useJsonCheckMessages = () => {
	const { t } = useAppContext()
	return useMemo(
		() => (messageType?: ReturnMessageTypeEnum) => {
			if (!messageType) return ''
			const key = MESSAGE_KEYS[messageType]
			return key ? t(key) : messageType
		},
		[t],
	)
}
